import { Joi, actionCreator, literalAs, objectSchemaOf } from '../helpers';
import { PRESENCE_INPUT } from './topics';

export const ALERTS = 'PRESENCE/ALERTS' as const;

export interface IAlertsAction {
  type: typeof ALERTS;
}

export const alertsActionSchema = objectSchemaOf<IAlertsAction>({
  type: Joi.string().valid(ALERTS).required(),
});

export const alerts = actionCreator({
  type: ALERTS,
  topic: PRESENCE_INPUT,
  schema: alertsActionSchema,
  creator: () => literalAs<IAlertsAction>({ type: ALERTS }),
});
